import React, { useEffect } from 'react';
import { Redirect } from 'react-router-dom';

import { rememberPostLoginReturnPath } from './postLoginReturnPath';

interface LoginRedirectProps {
  /** The page the signed-out user asked for. */
  pathname: string;
  search: string;
}

/**
 * Sends a signed-out user to sign in. A password sign-in comes back through `state.from`, query string included; an
 * SSO sign-in leaves the SPA and loses it, which `rememberPostLoginReturnPath` makes up for.
 */
const LoginRedirect: React.FC<LoginRedirectProps> = ({ pathname, search }) => {
  useEffect(() => {
    rememberPostLoginReturnPath({ pathname, search });
  }, [pathname, search]);

  return <Redirect to={{ pathname: '/login', state: { from: `${pathname}${search}` } }} />;
};

export default LoginRedirect;
